import React, { useEffect, useMemo, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { MenuItem, Select, Box, FormControl, InputLabel, TextField, Checkbox, FormControlLabel } from "@mui/material";
import moment from "moment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"; // Custom icon
import CustomButton from "./CustomButton";

const DateFilter = ({ open, range, setRange, setOpen }) => {
    const [selectedRange, setSelectedRange] = useState("Last 7 Days");


    const predefinedRanges = useMemo(() => ({
        Today: [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
        Yesterday: [
            moment().subtract(1, "days").startOf("day").toDate(),
            moment().subtract(1, "days").endOf("day").toDate(),
        ],
        "Last 7 Days": [moment().subtract(6, "days").toDate(), new Date()],
        "Last 30 Days": [moment().subtract(29, "days").toDate(), new Date()],
        "Last Month": [
            moment().subtract(1, "month").startOf("month").toDate(),
            moment().subtract(1, "month").endOf("month").toDate(),
        ],
        "This Month": [moment().startOf("month").toDate(), new Date()],
        "Last Quarter": [
            moment().subtract(1, "quarter").startOf("quarter").toDate(),
            moment().subtract(1, "quarter").endOf("quarter").toDate(),
        ],
        "This Quarter": [moment().startOf("quarter").toDate(), new Date()],
        "Last Financial Year": [
            moment().subtract(1, "year").startOf("year").toDate(),
            moment().subtract(1, "year").endOf("year").toDate(),
        ],
        "This Financial Year": [moment().startOf("year").toDate(), new Date()],
    }), []);
    

    useEffect(() => {
        if (selectedRange !== "Custom" && predefinedRanges[selectedRange]) {
            setRange({
                startDate: predefinedRanges[selectedRange][0],
                endDate: predefinedRanges[selectedRange][1],
                key: "selection",
            });
        }
    }, [selectedRange, predefinedRanges, setRange]);

    const handleSelect = (ranges) => {
        setRange(ranges.selection);
        setSelectedRange("Custom");
    };

    const handleFilterChange = (event) => {
        setSelectedRange(event.target.value);
    };

    const handleInputChange = (event, type) => {
        const newDate = moment(event.target.value, "MM/DD/YYYY", true);
        if (newDate.isValid()) {
            setRange((prevRange) => ({
                ...prevRange,
                [type]: newDate.toDate(),
            }));
        }
    };

    return (
        <Box sx={{ p: 2, position: "absolute", zIndex: 999, maxWidth: '400px', background: "#fff", borderRadius: 2, boxShadow: 3, display: open ? 'block' : 'none' }}>
            {/* Dropdown Filter */}
            <FormControl sx={{ width: "100%" }}>
                <InputLabel id="date-range-label">Date Range</InputLabel>
                <Select
                    labelId="date-range-label"
                    id="date-range-select"
                    value={selectedRange}
                    onChange={handleFilterChange}
                    label="Date Range"
                    fullWidth
                    IconComponent={ArrowDropDownIcon}
                    SelectDisplayProps={{
                        sx: { padding: "8px", color: "red" },
                    }}
                    sx={{
                        zIndex: 9999,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "8px",
                        },
                        "& .MuiMenu-list": {
                            border: "1px solid #ddd",
                            marginTop: "8px",
                            padding: "4px",
                        },
                    }}
                >
                    {Object.keys(predefinedRanges).map((label) => (
                        <MenuItem key={label} value={label} sx={{ width: "100%" }} >
                            {label}
                        </MenuItem>
                    ))}
                    <MenuItem value="Custom">Custom Range</MenuItem>
                </Select>
            </FormControl>

            {/* Date Inputs Styled Like Image */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                <TextField
                    label="Starting"
                    value={moment(range.startDate).format("MM/DD/YYYY")}
                    variant="outlined"
                    fullWidth
                    sx={{ mr: 1 }}
                    onChange={(e) => handleInputChange(e, "startDate")}
                />
                <TextField
                    label="Ending"
                    value={moment(range.endDate).format("MM/DD/YYYY")}
                    variant="outlined"
                    fullWidth
                    sx={{ ml: 1 }}
                    onChange={(e) => handleInputChange(e, "endDate")}
                />
            </Box>

            {/* Always Open Date Picker */}
            <Box sx={{ mt: 2 }}>
                <DateRangePicker
                    onChange={handleSelect}
                    moveRangeOnFirstSelection={false}
                    ranges={[range]}
                    showSelectionPreview={true}
                    showMonthAndYearPickers={true}
                    editableDateInputs={true}
                    months={2}
                    direction="horizontal"
                    dateDisplayFormat="MM/dd/yyyy"
                    initialFocusedRange={[0, 0]}
                    shownDate={moment(range.startDate).toDate()} // Set first month dynamically
                    className="custom-date-picker"
                    rangeColors={["#3b82f6"]}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                        // checked={checkedItems[index] || false}
                        // onChange={() => handleCheckboxChange(index)}
                        />
                    }
                    label={'Compare to previous dates'}
                />
                <Box sx={{ display: 'flex', justifyContent: "flex-end" }}>
                    <Box sx={{ display: "flex", justifyContent: 'space-between', width: "50%" }}>
                        <CustomButton bgcolor={"#3D52A0"} text={"Apply"} color={"white"} onClick={() => setOpen(false)} />
                        <CustomButton bgcolor={"transparent"} text={"Cancel"} color={"black"} onClick={() => setOpen(false)} />
                    </Box>
                </Box>


            </Box>
        </Box>
    );
};

export default DateFilter;